module.exports = __webpack_public_path__ + "ebc87081414bce7a8c24b7cff4ab7194.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_5.png
// module id = 129
// module chunks = 1